<app-dialog-title
  class="g-flex-column__item-fixed"
  [title]="'bottles-dialog.title' | translate"
  (closeDialog)="close()">
</app-dialog-title>

<div
  class="content g-flex-column__item g-flex g-flex--justify-center g-flex--wrap g-scroll-y"
  [class.g-flex--align-start]="items.length"
  [class.g-flex--align-center]="!items.length">
  @if (loading) {
    <br />
    <br />
    <br />
    <app-loading-small class="page-loader"></app-loading-small>
  } @else {
    @if (items.length) {
      @for (item of items; track item) {
        <app-item-slot
          class="inventory__all_slot-item"
          [slotItem]="item"
          [clickOnItemImg]="true"
          slotSize="huge"
          (clickEmit)="openItemDescriptionDialog(item)">
        </app-item-slot>
      }
    } @else {
      <div>
        {{ 'bottles-dialog.no-items' | translate }}
      </div>
    }
  }
</div>
